// @ts-nocheck
// @ts-ignore
// docs: https://github.com/binarcode/vue2-transitions
import Vue from 'vue'
import transitions from 'vue2-transitions'
Vue.use(transitions)
export const Transitions = transitions
